<nb-select fullWidth [(selected)]="value" [disabled]="isDisabled">
  <nb-option *ngFor="let option of BuildingType" [value]="option">{{ option | buildingTypeTranslation }}</nb-option>
</nb-select>
